import { Link } from 'react-router-dom';

export default function EEATSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="lg:w-[40%]">
            <span className="inline-block text-xs font-semibold uppercase tracking-wider text-accent-600 border border-accent-200 px-3 py-1 rounded-full">
              Autorità EEAT
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-4 leading-tight">
              Esperienza Reale
              <br />
              <span className="font-normal italic text-foreground-600">e Trust</span>
            </h2>
            <p className="mt-6 text-foreground-600 text-sm leading-relaxed max-w-md">
              Il nostro team analizza e testa personalmente ogni prodotto prima di inserirlo nello spreadsheet. 
              Seguiamo i rigorosi standard Google EEAT (Experience, Expertise, Authority, Trust) per garantire 
              che ogni raccomandazione sia basata su esperienza reale e verificata.
            </p>
            <p className="mt-4 text-foreground-600 text-sm leading-relaxed max-w-md">
              Ogni prodotto del nostro database è stato esaminato attraverso foto QC, verifiche sui venditori 
              e analisi comparative dei prezzi. Non pubblichiamo nulla che non abbiamo prima controllato.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mt-6">
              <Link
                to="/author"
                className="text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer transition-colors underline underline-offset-4"
              >
                Chi Siamo &rarr;
              </Link>
              <Link
                to="/about-itaobuy-spreadsheet"
                className="text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer transition-colors underline underline-offset-4"
              >
                La Nostra Missione &rarr;
              </Link>
            </div>
          </div>

          <div className="lg:w-[60%] flex flex-col gap-6">
            <div className="flex items-center gap-8 justify-end">
              <div className="text-right">
                <span className="text-4xl md:text-5xl font-heading font-bold text-foreground-900">500+</span>
                <p className="text-xs text-foreground-500 mt-1">Guide SEO</p>
              </div>
              <div className="text-right">
                <span className="text-4xl md:text-5xl font-heading font-bold text-foreground-900">100K+</span>
                <p className="text-xs text-foreground-500 mt-1">Visite Mensili</p>
              </div>
            </div>

            <div className="flex gap-4 items-start">
              <div className="w-[180px] h-[220px] rounded-xl overflow-hidden flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20product%20reviewer%20workspace%20with%20laptop%20displaying%20spreadsheet%20beside%20neatly%20arranged%20sneakers%20and%20fabric%20swatches%2C%20morning%20light%20through%20large%20industrial%20windows%2C%20modern%20creative%20studio%20atmosphere%2C%20authentic%20editorial%20workspace%2C%20warm%20natural%20tones%20with%20muted%20olive%20accents%2C%20no%20visible%20screen%20content&width=400&height=500&seq=eeat-img-1-03&orientation=portrait&nocache=true"
                  alt="Product analysis workspace"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="w-[220px] h-[280px] rounded-xl overflow-hidden flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20haul%20display%20with%20carefully%20arranged%20clothing%20items%20accessories%20and%20detailed%20inspection%20notes%20on%20warm%20wooden%20surface%2C%20soft%20afternoon%20sunlight%20from%20floor%20to%20ceiling%20windows%2C%20high%20end%20editorial%20lifestyle%20photography%2C%20warm%20cognac%20and%20beige%20palette%20with%20subtle%20sage%2C%20aspirational%20yet%20authentic%2C%20no%20text&width=500&height=600&seq=eeat-img-2-04&orientation=portrait&nocache=true"
                  alt="Fashion items review"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}